import { useState, useRef } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import bgImage from "../assets/bg.jpg";
import { useNavigate } from "react-router-dom";

// import HPLoginModal from "./HPLoginModal"; // optional kalau ada

export default function LoginForm({ onLogin }) {
  const navigate = useNavigate();
  const [nik, setNik] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [hpLoginOpen, setHpLoginOpen] = useState(false);

  const inputsRef = useRef([]);
   const toastOptions = {
    duration: 3000,
    style: {
      background: "#f87171",
      color: "#fff",
      borderRadius: "0.5rem",
      padding: "0.75rem 1rem",
      fontWeight: "500",
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    },
  };
  // handle OTP input
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && index > 0) {
        inputsRef.current[index - 1]?.focus();
      }
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  // LOGIN 2FA
 // LOGIN 2FA
  const handleLogin2fa = async (e) => {
    e.preventDefault();

    const otpCode = otp.join("");

    if (otpCode.length !== 6) {
      toast.error("OTP harus 6 digit");
      return;
    }

    try {
      setLoadingLogin(true);

      const res = await axios.post("/api/login-2fa", {
        id_sunfish: nik,
        otp: otpCode,
      });

      if (res.data.success) {
        // 💡 1. Simpan semua data kredensial dasar user
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("id_sunfish", res.data.id_sunfish);
        localStorage.setItem("nama", res.data.nama);
        localStorage.setItem("kode_toko", res.data.kode_toko);
        localStorage.setItem("nama_toko", res.data.nama_toko);

        // 💡 2. SIMPAN HAK AKSES BARU KE LOCALSTORAGE
        // Pastikan backend Anda mengirimkan string ini (contoh nilai: 'asthead', 'head', 'manager', atau 'store_leader')
        // Jika dari api key-nya berbeda, sesuaikan bagian res.data.role_user dibawah ini.
        const userRole = res.data.role_user || "store_leader"; 
        localStorage.setItem("role_user", userRole);

        toast.success("Login sukses!", toastOptions);
        
        // Redirect ke halaman utama / dashboard
        navigate("/");
        
      } else {
        toast.error(res.data.message || "OTP salah atau NIK tidak valid", toastOptions);
      }

    } catch (err) {
      console.error("FULL ERROR:", err);

      if (err.response) {
        toast.error(
          err.response.data?.message || `Error ${err.response.status}`,
          toastOptions
        );
      } else if (err.request) {
        toast.error("Server tidak merespon / API tidak jalan", toastOptions);
      } else {
        toast.error(err.message || "Terjadi kesalahan", toastOptions);
      }
    } finally {
      setLoadingLogin(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-black">
      {/* LEFT */}
      <div
        className="hidden md:flex w-full bg-cover bg-center relative"
       style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/50 to-black/80 backdrop-blur-sm"></div>

        <div className="relative z-10 flex flex-col justify-center items-center w-full text-white px-10">
          <h1 className="text-4xl font-bold mb-4">Biensi Multichannel</h1>
          <p className="text-gray-300 text-center max-w-md">
            Sistem Point of Sales modern dengan keamanan 2FA dan integrasi penuh.
          </p>
        </div>
      </div>

      {/* RIGHT */}
      <div className="flex w-full md:w-1/2 justify-center items-center">
        <div className="bg-gray-900 p-10 rounded-xl shadow-lg w-full max-w-md">

          <h2 className="text-3xl font-bold text-white text-center mb-6">
            Login Multichannel
          </h2>

          {/* INFO */}
           <div className="bg-gray-800 text-gray-200 p-4 rounded-lg mb-5 text-sm space-y-2">
            <p className="font-semibold text-white">Cara masuk BMC:</p>
            <ol className="list-decimal list-inside space-y-1">
              <li>Masukkan <strong>ID Sunfish</strong></li>
              <li>Buka <strong>Google Authenticator</strong></li>
              <li>Masukkan <strong>6 digit OTP</strong></li>
              <li>Klik <strong>Masuk</strong></li>
            </ol>
          </div>

          {/* FORM */}
          <form onSubmit={handleLogin2fa} className="space-y-5">

            <input
              type="text"
              placeholder="ID Sunfish"
              value={nik}
              onChange={(e) => setNik(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-red-500 transition"
              required
            />

            {/* OTP */}
            <div className="flex justify-between gap-2">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  inputMode="numeric"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputsRef.current[index] = el)}
                  className="w-12 h-12 text-center text-white bg-gray-800 border border-gray-700 rounded-lg text-xl focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                />
              ))}
            </div>

            <button
              type="submit"
              disabled={loadingLogin}
              className="w-full bg-gradient-to-r from-red-500 to-red-700 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition-all shadow-lg"
            >
              {loadingLogin ? "Verifying..." : "Masuk dengan 2FA"}
            </button>
          </form>

          {/* LOGIN HP */}
          
          {/* TOASTER */}
          <Toaster position="bottom-center" />

          <p className="text-center text-gray-500 mt-6 text-sm">
            © 2026 Biensi Multicannel
          </p>
        </div>
      </div>
    </div>
  );
}